export default {
  'pages.layouts.userLayout.title':
    'পিঁপড়া ডিজাইন হচ্ছে সিহু জেলার সবচেয়ে প্রভাবশালী ওয়েব ডিজাইনের স্পেসিফিকেশন',
  'pages.login.accountLogin.tab': 'অ্যাকাউন্টে লগইন',
  'pages.login.accountLogin.errorMessage':
    'ভুল ব্যবহারকারীর নাম/পাসওয়ার্ড(admin/ant.design)',
  'pages.login.failure': 'লগইন ব্যর্থ হয়েছে। আবার চেষ্টা করুন!',
  'pages.login.success': 'সফল লগইন!',
  'pages.login.username.placeholder': 'ব্যবহারকারীর নাম: admin or user',
  'pages.login.username.required': 'আপনার ব্যবহারকারীর নাম ইনপুট করুন!',
  'pages.login.password.placeholder': 'পাসওয়ার্ড: ant.design',
  'pages.login.password.required': 'আপনার পাসওয়ার্ড ইনপুট করুন!',
  'pages.login.phoneLogin.tab': 'ফোন লগইন',
  'pages.login.phoneLogin.errorMessage': 'যাচাইকরণ কোড ত্রুটি',
  'pages.login.phoneNumber.placeholder': 'ফোন নম্বর',
  'pages.login.phoneNumber.required': 'আপনার ফোন নম্বর ইনপুট করুন!',
  'pages.login.phoneNumber.invalid': 'ফোন নম্বরটি সঠিক নয়!',
  'pages.login.captcha.placeholder': 'যাচাইকরণের কোড',
  'pages.login.captcha.required': 'দয়া করে ভেরিফিকেশন কোডটি ইনপুট করুন!',
  'pages.login.phoneLogin.getVerificationCode': 'কোড পান',
  'pages.getCaptchaSecondText': 'সেকেন্ড',
  'pages.login.rememberMe': 'আমাকে মনে রাখুন',
  'pages.login.forgotPassword': 'পাসওয়ার্ড ভুলে গেছেন?',
  'pages.login.submit': 'প্রবেশ করুন',
  'pages.login.loginWith': 'লগইন করতে পারেন:',
  'pages.login.registerAccount': 'অ্যাকাউন্ট নিবন্ধন করুন',
  'pages.welcome.link': 'স্বাগতম',
  'pages.welcome.alertMessage': 'দ্রুত এবং শক্তিশালী ভারী শুল্ক উপাদান প্রকাশ করা হয়েছে।',
  'pages.404.subTitle': 'দুঃখিত, আপনি যে পৃষ্ঠাটি দেখতে চান তা বিদ্যমান নেই।',
  'pages.404.buttonText': 'প্রধান পাতায় ফিরে যান',
  'pages.admin.subPage.title': 'এই পৃষ্ঠাটি কেবল অ্যাডমিন দ্বারা দেখা যাবে',
  'pages.admin.subPage.alertMessage':
    'UMI UI এখন প্রকাশিত হয়েছে, অভিজ্ঞতা শুরু করতে npm run ui ব্যবহার করতে স্বাগতম।',
  'pages.searchTable.createForm.newRule': 'নতুন বিধি',
  'pages.searchTable.updateForm.ruleConfig': 'বিধি কনফিগারেশন',
  'pages.searchTable.updateForm.basicConfig': 'মৌলিক তথ্য',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'বিধি নাম',
  'pages.searchTable.updateForm.ruleName.nameRules': 'বিধির নাম লিখুন!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'বিধির বিবরণ',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'কমপক্ষে পাঁচটি অক্ষর লিখুন',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'কমপক্ষে পাঁচটি অক্ষরের একটি বিধান বিবরণ লিখুন!',
  'pages.searchTable.updateForm.ruleProps.title': 'বৈশিষ্ট্য কনফিগার করুন',
  'pages.searchTable.updateForm.object': 'নিরীক্ষণ অবজেক্ট',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'বিধি টেম্পলেট',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'বিধি প্রকার',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'সময়সূচী নির্ধারণ করুন',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'শুরুর সময়',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'একটি শুরুর সময় চয়ন করুন!',
  'pages.searchTable.titleDesc': 'বর্ণনা',
  'pages.searchTable.ruleName': 'বিধি নাম প্রয়োজন',
  'pages.searchTable.titleCallNo': 'পরিষেবা কল সংখ্যা',
  'pages.searchTable.titleStatus': 'অবস্থা',
  'pages.searchTable.nameStatus.default': 'ডিফল্ট',
  'pages.searchTable.nameStatus.running': 'চলমান',
  'pages.searchTable.nameStatus.online': 'অনলাইন',
  'pages.searchTable.nameStatus.abnormal': 'অস্বাভাবিক',
  'pages.searchTable.titleUpdatedAt': 'সর্বশেষ নির্ধারিত',
  'pages.searchTable.exception': 'ব্যতিক্রম জন্য কারণ লিখুন!',
  'pages.searchTable.titleOption': 'অপশন',
  'pages.searchTable.config': 'কনফিগারেশন',
  'pages.searchTable.subscribeAlert': 'সতর্কতা সাবস্ক্রাইব করুন',
  'pages.searchTable.title': 'ইনকয়েরি ফরম',
  'pages.searchTable.new': 'নতুন',
  'pages.searchTable.chosen': 'নির্বাচিত',
  'pages.searchTable.item': 'আইটেম',
  'pages.searchTable.totalServiceCalls': 'পরিষেবা কলগুলির মোট সংখ্যা',
  'pages.searchTable.tenThousand': '000',
  'pages.searchTable.batchDeletion': 'একসাখে ডিলিট',
  'pages.searchTable.batchApproval': 'একসাখে অনুমোদন',
  
  // Order Statistics Page
  'pages.orders.statistics.title': 'অর্ডার পরিসংখ্যান',
  'pages.orders.statistics.dateRange': 'তারিখের পরিসর',
  'pages.orders.statistics.last7Days': 'গত ৭ দিন',
  'pages.orders.statistics.last30Days': 'গত ৩০ দিন',
  'pages.orders.statistics.last90Days': 'গত ৯০ দিন',
  'pages.orders.statistics.totalOrders': 'মোট অর্ডার সংখ্যা',
  'pages.orders.statistics.totalSales': 'মোট বিক্রয়',
  'pages.orders.statistics.refundCount': 'ফেরত দেওয়া পণ্যের সংখ্যা',
  'pages.orders.statistics.refundAmount': 'ফেরত দেওয়ার পরিমাণ',
  'pages.orders.statistics.trendChart': 'ব্যবসায়িক প্রবণতা গ্রাফ',
  'pages.orders.statistics.dailyStats': 'দৈনিক পরিসংখ্যান',
  'pages.orders.statistics.chart.orders': 'অর্ডার',
  'pages.orders.statistics.chart.revenue': 'রাজস্ব',
  'pages.orders.statistics.chart.refunds': 'ফেরত',
  'pages.orders.statistics.table.date': 'তারিখ',
  'pages.orders.statistics.table.orderCount': 'অর্ডার সংখ্যা',
  'pages.orders.statistics.table.revenue': 'রাজস্ব',
  'pages.orders.statistics.table.refundCount': 'ফেরত সংখ্যা',
  'pages.orders.statistics.table.refundAmount': 'ফেরত পরিমাণ',
  'pages.orders.statistics.table.total': 'মোট {total} আইটেম',

  // লাইভ রিবেট সেটিংস
  'pages.live.rebate.title': 'লাইভ রিবেট সেটিংস',
  'pages.live.rebate.liveTeamName': 'লাইভ টিমের নাম',
  'pages.live.rebate.memberId': 'সদস্য আইডি',
  'pages.live.rebate.sellerId': 'বিক্রেতা আইডি',
  'pages.live.rebate.sellerPercent': 'বিক্রেতা %',
  'pages.live.rebate.companyPercent': 'কোম্পানি %',
  'pages.live.rebate.teamPercent': 'টিম %',
  'pages.live.rebate.teamRebatePercent': 'টিম রিবেট %',
  'pages.live.rebate.settingTimeAdmin': 'সেটিং সময় / অ্যাডমিন',
  'pages.live.rebate.actions': 'কার্যক্রম',
  'pages.live.rebate.setting': 'সেটিং',
  'pages.live.rebate.detail': 'বিস্তারিত',
  'pages.live.rebate.delete': 'মুছুন',
  'pages.live.rebate.addRebate': 'রিবেট যোগ করুন',
  'pages.live.rebate.batchUpdate': 'ব্যাচ আপডেট',
  'pages.live.rebate.selectFirst': 'অনুগ্রহ করে প্রথমে আইটেম নির্বাচন করুন',
  'pages.live.rebate.addSuccess': 'রিবেট সফলভাবে যোগ করা হয়েছে',
  'pages.live.rebate.addFailed': 'রিবেট যোগ করতে ব্যর্থ',
  'pages.live.rebate.updateSuccess': 'রিবেট সফলভাবে আপডেট করা হয়েছে',
  'pages.live.rebate.updateFailed': 'রিবেট আপডেট করতে ব্যর্থ',
  'pages.live.rebate.deleteSuccess': 'রিবেট সফলভাবে মুছে ফেলা হয়েছে',
  'pages.live.rebate.deleteFailed': 'রিবেট মুছতে ব্যর্থ',
  'pages.live.rebate.deleteConfirm': 'রিবেট মুছুন',
  'pages.live.rebate.deleteContent': 'আপনি কি নিশ্চিত যে আপনি এই রিবেট সেটিং মুছতে চান?',
  'pages.live.rebate.addModalTitle': 'রিবেট সেটিং যোগ করুন',
  'pages.live.rebate.editModalTitle': 'রিবেট সেটিং সম্পাদনা করুন',
  'pages.live.rebate.liveTeamNameRequired': 'অনুগ্রহ করে লাইভ টিমের নাম লিখুন',
  'pages.live.rebate.memberIdRequired': 'অনুগ্রহ করে সদস্য আইডি লিখুন',
  'pages.live.rebate.sellerIdRequired': 'অনুগ্রহ করে বিক্রেতা আইডি লিখুন',
  'pages.live.rebate.sellerPercentRequired': 'অনুগ্রহ করে বিক্রেতার শতাংশ লিখুন',
  'pages.live.rebate.companyPercentRequired': 'অনুগ্রহ করে কোম্পানির শতাংশ লিখুন',
  'pages.live.rebate.teamPercentRequired': 'অনুগ্রহ করে টিমের শতাংশ লিখুন',
  'pages.live.rebate.teamRebatePercentRequired': 'অনুগ্রহ করে টিম রিবেটের শতাংশ লিখুন',
  'pages.live.rebate.loadFailed': 'রিবেট সেটিংস লোড করতে ব্যর্থ',
  'pages.live.rebate.selectAtLeastTwo': 'অনুগ্রহ করে কমপক্ষে ২টি আইটেম নির্বাচন করুন',
  'pages.live.rebate.batchSetting': 'ব্যাচ সেটিং',
  'pages.live.rebate.batchUpdateTitle': 'ব্যাচ শতাংশ আপডেট',
  'pages.live.rebate.selectedItems': 'আইটেম নির্বাচিত',
  'pages.live.rebate.applySetting': 'সেটিং প্রয়োগ করুন',
  'pages.live.rebate.cancel': 'বাতিল',
  'pages.live.rebate.batchUpdateSuccess': 'ব্যাচ আপডেট সফলভাবে সম্পন্ন হয়েছে',
  'pages.live.rebate.batchUpdateFailed': 'ব্যাচ আপডেট ব্যর্থ',
  'pages.live.rebate.searchLabel': 'অনুসন্ধান',
  'pages.live.rebate.searchPlaceholder': 'লাইভ টিমের নাম, বিক্রেতা আইডি বা সদস্য আইডি দিয়ে অনুসন্ধান করুন',
  'pages.live.rebate.search': 'অনুসন্ধান',
  'pages.live.rebate.reset': 'রিসেট',
  'pages.live.rebate.teamLead': 'টিম লিডার',
  'pages.live.rebate.teamLeadId': 'টিম লিডার আইডি',
  'pages.live.rebate.teamLeadIdRequired': 'অনুগ্রহ করে টিম লিডার আইডি লিখুন',
  'pages.live.rebate.teamInternalSelfPercent': 'টিম অভ্যন্তরীণ নিজস্ব %',
  'pages.live.rebate.teamInternalSelfPercentRequired': 'অনুগ্রহ করে টিম অভ্যন্তরীণ নিজস্ব শতাংশ লিখুন',
  'pages.live.rebate.teamInternalUplinePercent': 'টিম অভ্যন্তরীণ ঊর্ধ্বতন %',
  'pages.live.rebate.teamRebate': 'দলীয় রিবেট',
  'pages.live.rebate.memberSettings': 'সদস্য সেটিংস',
  'pages.live.rebate.memberSettingsTitle': 'বিক্রেতা-ভিত্তিক রিবেট সেটিংস',
  'pages.live.rebate.memberSettingsHint': 'প্রতিটি বিক্রেতার রিবেট % নির্ধারণ করুন। সংরক্ষিত মান সেই বিক্রেতার জন্য দলের সেটিংসের পরিবর্তে ব্যবহৃত হবে; "নির্ধারিত নয়" বিক্রেতারা দলের সেটিংস ব্যবহার করবে।',
  'pages.live.rebate.memberSource': 'উৎস',
  'pages.live.rebate.memberSourceTeamCopy': 'দল থেকে কপি',
  'pages.live.rebate.memberSourceAdmin': 'পৃথকভাবে নির্ধারিত',
  'pages.live.rebate.memberSourceNone': 'নির্ধারিত নয় (দলের সেটিংস)',
  'pages.live.rebate.memberSourceTeamConfig': 'দলের সেটিংস',
  'pages.live.rebate.memberSelfPercent': 'নিজের %',
  'pages.live.rebate.memberSave': 'সংরক্ষণ',
  'pages.live.rebate.memberSaveSuccess': 'বিক্রেতার রিবেট সেটিংস সংরক্ষিত হয়েছে',
  'pages.live.rebate.memberSaveFailed': 'বিক্রেতার রিবেট সেটিংস সংরক্ষণ ব্যর্থ হয়েছে',
  'pages.live.rebate.memberLoadFailed': 'দলের সদস্য লোড করতে ব্যর্থ',
  'pages.live.rebate.marginSumError': 'বিক্রেতা + কোম্পানি + দল % এর যোগফল ১০০ হতে হবে',
  'pages.live.rebate.teamLeadTag': 'দলনেতা',
  'pages.live.rebate.teamInternalUplinePercentRequired': 'অনুগ্রহ করে টিম অভ্যন্তরীণ ঊর্ধ্বতন শতাংশ লিখুন',
  'pages.live.rebate.configuredAt': 'কনফিগারেশনের সময়',
  'pages.live.rebate.configuredAtRequired': 'অনুগ্রহ করে কনফিগারেশনের সময় নির্বাচন করুন',
  'pages.live.sellers.userId': 'ইউজার আইডি',
  'pages.live.sellers.sellerId': 'সেলার আইডি',
  'pages.live.sellers.name': 'নাম',
  'pages.live.sellers.recommender': 'রেফারেল',
  'pages.live.sellers.team': 'টিম সংখ্যা',
  'pages.live.sellers.follower': 'ফলোয়ার',
  'pages.live.sellers.salesAmount': 'বিক্রয় পরিমাণ',
  'pages.live.sellers.salesCount': 'বিক্রয় সংখ্যা',
  'pages.live.sellers.rebate': 'রিবেট সংগ্রহ',
  'pages.live.sellers.refundAmount': 'ফেরত পরিমাণ',
  'pages.live.sellers.rebateDeduction': 'রিবেট কর্তন',
  'pages.live.sellers.liveStatus': 'লাইভ অবস্থা',
  'pages.live.sellers.liveStatus.live': 'লাইভ',
  'pages.live.sellers.liveStatus.idle': 'নিষ্ক্রিয়',
  'pages.live.sellers.homepage': 'হোমপেজ',
  'pages.live.sellers.homepageLink': 'লিংক',
  'pages.live.sellers.actions': 'পদক্ষেপ',
  'pages.live.rebate.levelDetailTitle': 'লাইভ টিম তালিকা',
  'pages.live.rebate.levelDetail.column.teamName': 'টিমের নাম',
  'pages.live.rebate.levelDetail.column.depth': 'লেভেল',
  'pages.live.rebate.levelDetail.column.userUniqueId': 'বিক্রেতা আইডি',
  'pages.live.rebate.levelDetail.column.userId': 'ব্যবহারকারী আইডি',
  'pages.live.rebate.levelDetail.column.userName': 'ব্যবহারকারীর নাম',
  'pages.live.rebate.levelDetail.column.subordinateSellerCount': 'অধীনস্থ সংখ্যা',
  'pages.live.rebate.levelDetail.column.salesAmountKrw': 'বিক্রয় পরিমাণ (KRW)',
  'pages.live.rebate.levelDetail.column.salesQuantity': 'বিক্রয় সংখ্যা',
  'pages.live.rebate.levelDetail.column.refundAmountKrw': 'ফেরতের পরিমাণ (KRW)',
  'pages.live.rebate.levelDetail.column.refundQuantity': 'ফেরতের সংখ্যা',
  'pages.live.rebate.levelDetail.column.teamRebateAccruedKrw': 'টিম রিবেট জমা (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateDeductedKrw': 'টিম রিবেট কর্তন (KRW)',
  'pages.live.rebate.levelDetail.column.teamRebateAfterRefundKrw': 'ফেরতের পর টিম রিবেট (KRW)',
  'pages.live.rebate.levelDetail.column.platformAccruedKrw': 'কোম্পানি জমা (KRW)',
  'pages.live.rebate.levelDetail.column.platformDeductedKrw': 'কোম্পানি কর্তন (KRW)',
  'pages.live.rebate.levelDetail.column.platformAfterRefundKrw': 'ফেরতের পর কোম্পানি (KRW)',
  'pages.live.rebate.levelDetail.column.action': 'কার্যক্রম',
  'pages.live.rebate.levelDetail.searchLabel': 'অনুসন্ধান:',
  'pages.live.rebate.levelDetail.searchPlaceholder': 'বিক্রেতা আইডি, ব্যবহারকারী আইডি বা ব্যবহারকারীর নাম দিয়ে অনুসন্ধান...',
  'pages.live.rebate.levelDetail.searchButton': 'অনুসন্ধান',
  'pages.live.rebate.levelDetail.resetButton': 'রিসেট',
  'pages.live.rebate.levelDetail.reloadButton': 'রিলোড',
  'pages.live.rebate.levelDetail.detailButton': 'বিস্তারিত',
  'pages.live.rebate.levelDetail.loadError': 'লাইভ রিবেট বিস্তারিত ডেটা লোড করতে ব্যর্থ',
  'pages.live.rebate.levelDetail.level1': 'লেভেল ১',
  'pages.live.rebate.levelDetail.level2': 'লেভেল ২',
  'pages.live.rebate.levelDetail.level3': 'লেভেল ৩',
  'pages.live.rebate.levelDetail.level4': 'লেভেল ৪',
};
